module.exports = __webpack_public_path__ + "img/el-salto.95d19c56.jpg";